__turbopack_context__.v({
  "container": "NoResultsState-module-scss-module__8rg9hW__container",
  "icon": "NoResultsState-module-scss-module__8rg9hW__icon",
  "message": "NoResultsState-module-scss-module__8rg9hW__message",
  "title": "NoResultsState-module-scss-module__8rg9hW__title",
});
